import type { TOC } from '@ember/component/template-only';
import { array, hash } from '@ember/helper';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert } from '@ember/render-modifiers';
import { PrismModal, PrismTabsContainer } from '@mylighthouse/prism-ember';
import perform from 'ember-concurrency/helpers/perform';
import { t } from 'ember-intl';
import GeneralButtonsButtonExport from 'lumen/components/general/buttons/button-export';
import HotelStrategyRoomtypeTabsTabGraph from 'lumen/components/hotel/strategy/roomtype/tabs/tab-graph';
import HotelStrategyTablesTableDetailRoomtype from 'lumen/components/hotel/strategy/tables/table-detail-roomtype';
import type HotelStrategyRoomtypeController from 'lumen/controllers/hotel/strategy/roomtype';
import { DETAIL_VIEW_TABS } from 'lumen/utils/constants/rate-strategy-constants';

interface HotelStrategyRoomtypeSignature {
  Args: {
    controller: HotelStrategyRoomtypeController;
    model: unknown;
  };
}

<template>
  {{! @glint-nocheck: Need to convert controller to *.ts }}
  {{! template-lint-disable no-duplicate-id }}
  {{#unless @controller.parentController.isLoading}}
    <PrismModal
      @onClose={{@controller.redirectOnClose}}
      @title={{t "strategy.block_title.roomtype_pattern"}}
      {{didInsert @controller.resetContainerDimensions}}
    >
      <:actions>
        <GeneralButtonsButtonExport
          @exportAction={{perform @controller.exportRSTableTask}}
          data-event-id="hotel-rate-strategy-detail-export"
          data-event-value={{@controller.router.currentRoute.localName}}
        />
      </:actions>
      <:default>
        <div
          class="rate-strategy-roomtype-modal modal--stretched"
          {{didInsert @controller.checkDefaultSelectedRoomtype}}
        >
          {{#if @controller.canRender}}
            <PrismTabsContainer
              @activeTabId={{@controller.tab}}
              @onSelectTab={{@controller.makeActiveTab}}
              @visibleTabIds={{array
                DETAIL_VIEW_TABS.GRAPH
                DETAIL_VIEW_TABS.TABLE
              }}
              as |TabsContainer|
            >
              <TabsContainer.header as |Header|>
                <Header.tab @id={{DETAIL_VIEW_TABS.GRAPH}}>
                  {{t "general.graph"}}
                </Header.tab>
                <Header.tab @id={{DETAIL_VIEW_TABS.TABLE}}>
                  {{t "general.table"}}
                </Header.tab>
              </TabsContainer.header>
              <TabsContainer.content as |Content|>
                <Content.tab @id={{DETAIL_VIEW_TABS.GRAPH}}>
                  <HotelStrategyRoomtypeTabsTabGraph
                    @params={{hash
                      hasRSData=@controller.hasRSData
                      height=@controller.height
                      roomtypeDataPerHotelInfo=@controller.roomtypeDataPerHotelInfo
                      selectedRoomtypeParam=@controller.roomtype
                      sortBy=@controller.sortBy
                      sortDirection=@controller.sortDirection
                      sortTableData=@controller.sortTableData
                      subtypes=@controller.subtypes
                      typeData=@controller.typeData
                      updateSelectedRoomType=@controller.updateSelectedRoomType
                      width=@controller.width
                    }}
                  />
                </Content.tab>
                <Content.tab @id={{DETAIL_VIEW_TABS.TABLE}}>
                  <HotelStrategyTablesTableDetailRoomtype
                    @containerHeight={{@controller.height}}
                    @onTableSort={{@controller.onTableSort}}
                    @roomtypeDataPerHotelInfo={{@controller.roomtypeDataPerHotelInfo}}
                    @sortBy={{@controller.sortBy}}
                    @sortDirection={{@controller.sortDirection}}
                    @sortFunction={{@controller.sortFunction}}
                    @sorts={{@controller.sorts}}
                    @subtypes={{@controller.subtypes}}
                  />
                </Content.tab>
              </TabsContainer.content>
            </PrismTabsContainer>
          {{/if}}
        </div>
      </:default>
    </PrismModal>
  {{/unless}}
</template> satisfies TOC<HotelStrategyRoomtypeSignature>;
